import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StateService } from '../../services/common/claim-year.service';

@Injectable({
  providedIn: 'root',
})
export class MenuItemGuard implements CanActivate {
    isRowData:any
  constructor(private readonly router: Router, private readonly snackBar: MatSnackBar,private readonly sharedDataService: StateService,) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.sharedDataService.IsRowData$.subscribe((isRowData: any) => {
      this.isRowData = isRowData;
    });
    this.isRowData =  this.sharedDataService.getMenuRowData();
      if(this.isRowData){
        localStorage.removeItem('menuRowData');
        return false;
      }
   // const isRowData = route.data['isRowData'];
    // Allow navigation if 'isRowData' is false
    localStorage.removeItem('menuRowData');
    return true;
    
  }
  
}
